import axios from 'axios';
import qs from "qs";

import {
	Loading,
	Message,
	Notification
} from 'element-ui'

axios.defaults.timeout = 5000;
axios.defaults.baseURL = '';
axios.defaults.withCredentials = true; //设置session不变化


let loading //定义loading变量
function startLoading() {
	//使用Element loading-start 方法
	loading = Loading.service({
		text: '加载中……',
		background: 'rgba(0, 0, 0, 0.7)'
	})
}

function endLoading() { //使用Element loading-close 方法
	loading.close()
}
// startLoading()
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading()
	}
	needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
	if (needLoadingRequestCount <= 0) return
	needLoadingRequestCount--
	if (needLoadingRequestCount === 0) {
		endLoading()
	}
}


// '++++++++++++++++++++'
//http request 请求 拦截器

axios.interceptors.request.use(config => {
	console.log(config)
	// 安全策略配置
	config.withCredentials = true;

	if (window.localStorage.getItem('token')) {
		config.headers.token = window.localStorage.getItem('token')
	}
	// config.method === 'post'
	// 	? config.data = qs.stringify({ ...config.data })
	// 	: config.params = { ...config.params }
	// config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	showFullScreenLoading()
	return config
}, error => {
	Message.error({
		message: '加载超时'
	})
	return Promise.reject(error)
})

//http response 接口响应拦截器

axios.interceptors.response.use(function (response) { // 添加响应拦截器
	console.log(response)
	tryHideFullScreenLoading()
	return response;
}, function (error) {
	endLoading();
	Message.error({
		message: '接口错误'
	})
	return Promise.reject(error)
});



//导出axios插件
export default axios;